import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session - use callback to avoid setState in effect warning
    const initializeAuth = () => {
      const storedToken = localStorage.getItem('mytour_token');
      const storedUser = localStorage.getItem('mytour_user');
      
      if (storedToken && storedUser) {
        try {
          return { token: storedToken, user: JSON.parse(storedUser) };
        } catch {
          return { token: null, user: null };
        }
      }
      return { token: null, user: null };
    };

    const { token: initToken, user: initUser } = initializeAuth();
    if (initToken && initUser) {
      setToken(initToken);
      setUser(initUser);
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const response = await authAPI.login({ username, password });
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('mytour_token', newToken);
    localStorage.setItem('mytour_user', JSON.stringify(userData));
    
    setToken(newToken);
    setUser(userData);
    
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('mytour_token');
    localStorage.removeItem('mytour_user');
    setToken(null);
    setUser(null);
  };

  const updateUser = (newUserData) => {
    const updated = { ...user, ...newUserData };
    localStorage.setItem('mytour_user', JSON.stringify(updated));
    setUser(updated);
  };

  const isAuthenticated = !!token && !!user;

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      isAuthenticated,
      login,
      logout,
      updateUser,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
